<!-- ======= Footer ======= -->
<footer id="footer">
    <div class="footer-newsletter">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-4">
                    <h1 class="text-center">{{ 'Footer.KEEP_IN_TOUCH' | translate }}</h1>
                    <p class="text-center">{{ 'Footer.CONTACT_US_DESCRIPTION' | translate }}</p>
                </div>
                <div class="col-lg-4"></div>
                <div class="col-lg-4">
                    <h4 class="text-center">{{ 'Footer.DOWNLOAD_APP_NOW' | translate }}</h4>
                    <div class="row">
                        <div class="col-6">
                            <a href="{{googlePlayDownloadUrl}}">
                                <img src="../../../assets/images/google-play.png" alt="" class="img-fluid">
                            </a>
                        </div>
                        <div class="col-6">
                            <a href="{{appleStoreDownloadUrl}}">
                                <img src="../../../assets/images/store-apple-app.png" alt="" class="img-fluid">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="footer-top">
        <div class="container">
            <div class="row">
                <div class="col-lg-3 col-md-12 col-9 m-auto mb-5 footer-contact">
                    <a href="">
                        <img [src]="logoUrl" [alt]=" ('Tenant.Company_Name' | translate) + 'Logo'" class="img-fluid">
                    </a>
                    <p class="text-center mt-0">{{ 'Footer.MAKE_INVESTMENT_SIMPLE' | translate }}</p>
                </div>

                <div class="col-lg-9 col-md-12">
                    <div class="row">
                        <div class="col-lg-3 col-6 footer-links">
                            <h4>{{ 'Footer.INVESTMENT' | translate }}</h4>
                            <ul>
                                <li><i class="ri-arrow-right-s-line"></i> <a [routerLink]="['/opportunities']">{{ 'Footer.INVESTMENT_OPPORTUNITIES' | translate }}</a></li>
                            </ul>
                        </div>
                        <ng-container *ngFor="let menu of menus">
                        <div class="col-lg-3 col-6 footer-links" *ngIf="menu.isActive">
                           
                            <h4 >{{ languageService.currentLanguage=='en'?menu.titleEn:menu.titleAr }}</h4>
                            <ul>
                                <ng-container *ngFor="let menuItem of menu.profileMenuItems">
                                <li *ngIf="menuItem.isActive"><i class="ri-arrow-right-s-line"></i> <a [routerLink]="['/faq/'+menuItem.profileMenuType]">{{ languageService.currentLanguage=='en'?menuItem.titleEn:menuItem.titleAr}}</a></li>
                            </ng-container>
                            </ul>
                        </div>
                    </ng-container>


                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container py-4 pb-5 mb-0 mb-md-5 mb-xl-0">
        <div class="copyright">
            &copy; 2025 <strong><span>{{ ('Tenant.Company_Name' | translate) }}</span></strong>. {{ 'Footer.ALL_RIGHTS_RESERVED' | translate }}
        </div>
        <div class="social pb-4">
            <div class="social-links">
                <a href="{{twitterUrl}}" class="twitter"><i class="ri-twitter-x-fill"></i></a>
                <a href="{{linkedinUrl}}" class="linkedin"><i class="ri-linkedin-fill"></i></a>
            </div>
        </div>
    </div>
</footer>

<!-- End Footer -->